import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useGetUserContextQuery } from '@/entities/layout';
import { baseApi } from '@/shared/api/base';
import { API_TAGS } from '@/shared/api/tags';
import { useProjectSiteParams } from '@/shared/lib';
import type { AppDispatch } from '@/app/types/store';

import { buildProjectSitePath } from '../lib/build-project-site-path';

export const useProjectSiteSwitch = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { data: userContext } = useGetUserContextQuery();
  const { projectId, siteId } = useProjectSiteParams();

  const switchSite = (selectedProjectId: number, selectedSiteId: number) => {
    if (selectedProjectId === projectId && selectedSiteId === siteId) return;

    const project = userContext?.projects.find((p) => p.id === selectedProjectId);
    const site = project?.sites.find((s) => s.id === selectedSiteId);
    if (!project || !site) return;

    dispatch(
      baseApi.util.invalidateTags([
        { type: API_TAGS.LAYOUT, id: `${selectedProjectId}-${selectedSiteId}` },
        API_TAGS.DASHBOARD,
        API_TAGS.TRANSPORT,
        API_TAGS.STORAGE,
        API_TAGS.SERVICE_USERS,
        API_TAGS.MAPPING,
        API_TAGS.OPTIONS
      ])
    );

    navigate(buildProjectSitePath(project, site, window.location), { replace: true });
  };

  return { projects: userContext?.projects, projectId, siteId, switchSite };
};
